import React from 'react';
import {
    BrowserRouter,
    Switch,
    Route
} from "react-router-dom";
import IndexPage from './pages/IndexPage/IndexPage';
import PageHeader from "./components/PageHeader/PageHeader";
import ArticleListPage from "./pages/ArticleListPage/ArticleListPage";
import moment from 'moment';
import 'moment/locale/zh-cn'
import ArticleDetailPage from "./pages/ArticleDetailPage/ArticleDetailPage";

import './App.css';
import './utils/common.scss';
import PageFooter from "./components/PageFooter/PageFooter";

moment.lang('zh-cn');

function App() {
    return (
        <div>
            <PageHeader/>
            <BrowserRouter>
                <Switch>
                    <Route path="/article/detail/:id" component={ArticleDetailPage}/>
                    <Route path="/article/:type" component={ArticleListPage}/>
                    <Route path="/" component={IndexPage}/>
                </Switch>
            </BrowserRouter>
            <br/>
            <PageFooter/>

            {/*<header className="App-header">*/}
            {/*    <img src={logo} className="App-logo" alt="logo"/>*/}
            {/*    <p>*/}
            {/*        Edit <code>src/App.tsx</code> and save to reload.*/}
            {/*    </p>*/}
            {/*    <a*/}
            {/*        className="App-link"*/}
            {/*        href="https://reactjs.org"*/}
            {/*        target="_blank"*/}
            {/*        rel="noopener noreferrer"*/}
            {/*    >*/}
            {/*        Learn React*/}
            {/*    </a>*/}
            {/*</header>*/}
        </div>
    );
}

export default App;
